/**
 * Login Page
 * User authentication with Clerk components
 * Supports redirect_url query param for app-to-auth redirects
 */

import React from 'react';
import { SignIn } from '@clerk/clerk-react';
import { useSearchParams } from 'react-router-dom';

export const Login: React.FC = () => {
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirect_url');

  return (
    <div className="auth-container">
      <div className="flex justify-center">
        <SignIn
          appearance={{
            elements: {
              rootBox: 'mx-auto',
              card: 'shadow-lg',
            },
          }}
          routing="path"
          path="/login"
          signUpUrl="/register"
          forceRedirectUrl={redirectUrl || '/dashboard'}
          // Clerk will use redirect_url from URL if present, otherwise fallback to /dashboard
          fallbackRedirectUrl={redirectUrl || '/dashboard'}
          signUpFallbackRedirectUrl={redirectUrl || '/dashboard'}
        />
      </div>
    </div>
  );
};
